import { VStack, StackProps } from '@chakra-ui/react'
import React, { FC } from 'react'
import { BodyBackgroundNuance, useColor } from '../../theme'

interface IUnauthenticatedContainerProps extends StackProps {
  hasErrors?: boolean
  isFitContent?: boolean
  dataTestId?: string
}

export const UnauthenticatedContainer: FC<IUnauthenticatedContainerProps> = ({
  hasErrors,
  isFitContent,
  dataTestId,
  children,
  ...stackProps
}) => {
  const bodyBgColor = useColor({ nuance: BodyBackgroundNuance.Clean, palette: 'body' })

  return (
    <VStack
      bgColor={bodyBgColor}
      borderRadius="3xl"
      data-testid={dataTestId}
      pb={hasErrors ? 4 : 14}
      pos="relative"
      pt={14}
      px={24}
      spacing={4}
      width={isFitContent ? 'fit-content' : 'lg'}
      {...stackProps}
    >
      {children}
    </VStack>
  )
}
